import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-not-found',
  imports: [],
  standalone: true,
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {}
